import React, { FC } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Tile } from 'components/commercetools-ui/organisms/header/types';
import Markdown from 'components/commercetools-ui/organisms/markdown';
import HeaderDropdownTile from './header-menu-tile';
import { useParams } from 'next/navigation';
import { updateNonLocaleUrlsToUrlsWithLocale } from 'helpers/utils/urlHelper';

export interface Props {
  show: boolean | undefined;
  links: any[];
  tileContent?: Tile;
  onClick?: () => void;
}

const MenuDropdown: FC<Props> = ({ show, links, tileContent, onClick }) => {
  const wrapperClassNames = `menu-dropdown-wrapper ${show ? 'show' : 'hide'}`;
  const linksClassNames = `flex flex-wrap gap-[3.25rem] menu-link-container ${tileContent ? 'pr-lg-5' : ''}`;
  const { locale } = useParams();
  return (
    <div className={wrapperClassNames}>
      <div className={linksClassNames}>
        {links?.map((link) => (
          <div
            key={link?.label}
            className={`${
               link?.title === 'Media Hub'
               ? 'md:w-5/7 lg:w-5/7 ml-[6rem]' 
               : link?.title === 'Tools & Technical Downloads'
               ? 'md:w-5/7 lg:w-5/7'  
               : link?.mega_menu.length === 2
                ? 'w-1/2 items-start justify-start 2xl:flex 2xl:w-full 2xl:flex-col'
                : link?.mega_menu.length === 4 || link?.title === 'Solutions'
                ? (locale === 'nz' && link?.title !== 'Solutions') ? '' : 'w-1/3 ' 
                : link?.title === 'Sectors' || link?.title === 'About Us'
                ? 'w-2/3 xl:w-[58.33%]'
                : link?.mega_menu.length === 7 || link?.mega_menu.length === 5
                ? 'w-2/3 xl:w-[58.33%]'
                : link?.mega_menu.length === 8
                ? 'w-1/2 xl:w-[58.33%]'
                : link?.mega_menu.length === 6
                ? 'w-1/2'
                : 'w-full'
            }`}
          >
            <div className="pb-2 2xl:pb-4">
              <Link link={link?._url} variant="menu-header" className="text-nowrap">
                {link?.title === 'Support' && link?.mega_menu.length === 2 ? (
                  <Typography className="menu-section-title custom-title-fix">{link?.title}</Typography>
                ) : (
                  <Typography className="menu-section-title">{link?.title}</Typography>
                )}
              </Link>
            </div>
            <div
               className={`grid ${
                link?.title === 'Solutions'
                  ? 'menu-tile-solutions relative grid-cols-2 '
                  : link?.title === 'Sectors' ||
                    link?.mega_menu.length === 7 ||
                    link?.mega_menu.length === 5 
                  ? 'sector-menu-tile grid-cols-4 gap-x-1 gap-y-2 lg:gap-x-4 2xl:gap-x-5 2xl:gap-y-3 mt-[8px]'
                  : link?.mega_menu.length === 8
                  ? 'grid-cols-3 gap-[12px]'
                  : link?.mega_menu.length === 4
                  ? `tools-menu-tile grid-cols-2 gap-x-3 gap-y-[15px] xl:gap-x-5 mt-[8px]`
                  : link?.mega_menu.length === 3
                        ? 'support-menu grid-cols-5 gap-x-[0px] gap-y-5 mt-[8px] lg:gap-x-[3rem] xl:gap-x-[3rem] 2xl:gap-x-[3rem]' : 'about-menu-tile grid-cols-3 gap-4 2xl:gap-5 mt-[8px]'               
              }`}
            >
              {link?.mega_menu &&
                link?.mega_menu?.map((field: any, idx:any) => (
                  <>
                    {field?.mega_menu_url?.href === '' ? (
                      <Markdown markdown={updateNonLocaleUrlsToUrlsWithLocale(field?.mega_menu_content, locale)} className="markdown-custom" />
                    ) : (
                      <>
                        {link?.title === 'Solutions' ? (
                         <div className={`flex ${idx === 3 && locale === 'nz' && 'absolute top-[90%]'} flex-start`}>
                            <Link
                              key={field?.categoryId}
                              link={field?.mega_menu_url?.href}
                              className="markdown-custom  link-inline-block"
                              target={field?.mega_menu_url?.href?.includes('https://') ? '_blank' : ''}
                            >
                              <Markdown markdown={field?.mega_menu_content} />
                            </Link>
                          </div>
                        ) : (
                          <Link
                            key={field?.categoryId}
                            link={field?.mega_menu_url?.href}
                            className="markdown-custom"
                            target={field?.mega_menu_url?.href?.includes('https://') ? '_blank' : ''}
                          >
                            <Markdown markdown={field?.mega_menu_content} />
                          </Link>
                        )}
                      </>
                    )}
                  </>
                ))}
            </div>
          </div>
        ))}
      </div>
      {tileContent && <HeaderDropdownTile tileContent={tileContent} />}
    </div>
  );
};

export default MenuDropdown;
